import React from "react";

import styles from "./style.module.scss";
import SelectField from "../SelectField";
import TextField from "../TextField";
import CheckboxField from "../CheckboxField";
import { useGetCountryOptions } from "../../useCases/country";
import { MessageID } from "../../i18n/types";

interface NewAddressFieldsProps {
  checkboxDescriptionId: MessageID;
  country: string;
  address1: string;
  address2: string;
  saveForFutureUse: boolean;
  setCountry: (value: string) => void;
  setAddress1: (value: string) => void;
  setAddress2: (value: string) => void;
  setSaveForFutureUse: (value: boolean) => void;
  isDisabled?: boolean;
}

const NewAddressFields: React.FC<NewAddressFieldsProps> = (
  props: NewAddressFieldsProps
) => {
  const {
    isDisabled,
    country,
    address1,
    address2,
    saveForFutureUse,
    setCountry,
    setAddress1,
    setAddress2,
    setSaveForFutureUse,
    checkboxDescriptionId,
  } = props;
  const countryOptions = useGetCountryOptions();

  return (
    <div className={styles.fields}>
      <SelectField
        className={styles.textField}
        labelMessageId="view.addressForm.country"
        inputName="country"
        options={countryOptions}
        value={country}
        onSelectChange={setCountry}
        disabled={isDisabled}
      />
      <TextField
        className={styles.textField}
        labelMessageId="view.addressForm.roomUnitFloorBuilding"
        inputType="address1"
        inputName="address1"
        autoComplete="address1"
        placeholderMessageID="view.addressForm.roomUnitFloorBuilding"
        value={address1}
        onTextChange={setAddress1}
        disabled={isDisabled}
      />
      <TextField
        className={styles.textField}
        labelMessageId="view.addressForm.estateAddressDistrict"
        inputType="address2"
        inputName="address2"
        autoComplete="address2"
        placeholderMessageID="view.addressForm.estateAddressDistrict"
        value={address2}
        onTextChange={setAddress2}
        disabled={isDisabled}
      />
      <CheckboxField
        className={styles.checkboxField}
        isEnabled={saveForFutureUse}
        setEnabled={setSaveForFutureUse}
        checkboxDescriptionId={checkboxDescriptionId}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default NewAddressFields;
